import React, { useEffect, useState } from 'react';
import ReactDOMServer from 'react-dom/server';
import { ConvertApexBarChart, XLSXUtil } from '@datatox-bi/util';
import { SiMicrosoftexcel } from 'react-icons/si';
import Chart from 'react-apexcharts';

const defaultColors = [
    '#2E93fA',
    '#66DA26',
    '#546E7A',
    '#E91E63',
    '#FF9800',
    '#ff7f50',
    '#87cefa',
    '#da70d6',
    '#32cd32',
    '#6495ed',
    '#ff69b4',
    '#ba55d3',
    '#cd5c5c',
    '#ffa500',
    '#40e0d0',
];

const ApexLineChart = ({ datasetDruid, title, uiConfig }) => {
    const [dataset, setDataset] = useState(null);
    useEffect(() => {
        const [categories, series, colors, tickAmount] = ConvertApexBarChart.toApexLineChart({ datasetDruid: [...datasetDruid], defaultColors, ...uiConfig });
        setDataset([categories, series, colors, tickAmount]);
    }, []);

    if (dataset === null) {
        return 'loading';
    }

    if (datasetDruid.length <= 1) {
        return 'Nenhum dado';
    }

    const [categories, series, colors, tickAmount] = dataset;

    const config = {
        series,
        chart: {
            type: 'line',
            height: 500,
            // // height: 'auto',
            // width: '100%',
            // stacked: true,
            // animations: {
            //     enabled: !!uiConfig?.enableAnimation,
            // },
        },
        // plotOptions: {
        //     line: {
        //         horizontal: true,
        //     },
        // },
        // colors: colors,
        stroke: {
            curve: 'straight',
        },
        xaxis: {
            categories,
            // tickAmount,
        },
        // yaxis: {
        //     title: {
        //         text: undefined,
        //     },
        // },
        grid: {
            row: {
                colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                opacity: 0.5,
            },
        },
        // dataLabels: {
        //     enabled: false,
        // },
        fill: {
            opacity: 1,
        },
        // legend: {
        //     position: 'top',
        //     horizontalAlign: 'left',
        // },
        // responsive: [
        //     {
        //         // breakpoint: 480,
        //         options: {
        //             chart: {
        //                 // width: 1000,
        //             },
        //             legend: {
        //                 position: 'bottom',
        //             },
        //         },
        //     },
        // ],
    };

    return <Chart options={config} series={config.series} type="line" height={300} />;
};

export default ApexLineChart;
